import React from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSwitcher.css";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);

    // Update URL to reflect the language change
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const currentHash = window.location.hash;

    let newPath;

    // If current path already has a language code, replace it
    if (currentPath.match(/\/total\/[a-z]{2}\/image-translator/)) {
      newPath = currentPath.replace(
        /\/total\/[a-z]{2}\/image-translator/,
        `/total/${lng}/image-translator`
      );
    } else if (
      currentPath === "/total/image-translator" ||
      currentPath.startsWith("/total/image-translator/")
    ) {
      // If no language in path, add it
      newPath = currentPath.replace(
        /^\/total\/image-translator/,
        `/total/${lng}/image-translator`
      );
    } else {
      // Fallback
      newPath = `/total/${lng}/image-translator`;
    }

    // Preserve query parameters and hash
    const fullUrl = newPath + currentSearch + currentHash;
    window.history.pushState({}, "", fullUrl);
  };

  return (
    <div className="language-switcher">
      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="language-switcher-select"
        aria-label="Language"
      >
        <option value="en">English</option>
        <option value="es">Español</option>
        <option value="zh">中文</option>
        <option value="fr">Français</option>
        <option value="it">Italiano</option>
        <option value="de">Deutsch</option>
        <option value="ja">日本語</option>
        <option value="ar">العربية</option>
        <option value="ru">Русский</option>
        <option value="uk">Українська</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
